import { Suspense } from 'react'
import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { HomeFallback } from '@/routes/home/fallback'
import { Page } from '@/routes/home/page'

export const Home = () => {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<HomeFallback />}>
        <Page />
      </Suspense>
    </PageErrorBoundary>
  )
}
